var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.64748 25H18.7475C22.1975 25 23.5725 22.8875 23.735 20.3125L24.385 9.9875C24.56 7.2875 22.41 5 19.6975 5C18.935 5 18.235 4.5625 17.885 3.8875L16.985 2.075C16.41 0.9375 14.91 0 13.635 0H10.7725C9.48497 0 7.98497 0.9375 7.40998 2.075L6.50997 3.8875C6.15997 4.5625 5.45998 5 4.69747 5C1.98498 5 -0.165025 7.2875 0.00997505 9.9875L0.659975 20.3125C0.809975 22.8875 2.19748 25 5.64748 25Z",
    fill: "#333448"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0723 8.4375H10.3223C9.80977 8.4375 9.38477 8.0125 9.38477 7.5C9.38477 6.9875 9.80977 6.5625 10.3223 6.5625H14.0723C14.5848 6.5625 15.0098 6.9875 15.0098 7.5C15.0098 8.0125 14.5848 8.4375 14.0723 8.4375Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2016 20.1609C14.535 20.1609 16.4266 18.2693 16.4266 15.9359C16.4266 13.6025 14.535 11.7109 12.2016 11.7109C9.86816 11.7109 7.97656 13.6025 7.97656 15.9359C7.97656 18.2693 9.86816 20.1609 12.2016 20.1609Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.c181b6beb63dc533fd20d4d06b1d9dcc.svg";
export { ForwardRef as ReactComponent };